import {
  GET_REPOSITORY_REQUEST,
  GET_REPOSITORY_SUCCESS,
  GET_REPOSITORY_FAILURE,
  GET_FOLDER_REQUEST,
  GET_FOLDER_SUCCESS,
  GET_FOLDER_FAILURE,
  GET_TARGET_FOLDER_REQUEST,
  GET_TARGET_FOLDER_SUCCESS,
  GET_TARGET_FOLDER_FAILURE,
  EXPLORE_FOLDER_SUCCESS,
  GET_TARGET_FOLDERS_REQUEST,
  GET_TARGET_FOLDERS_SUCCESS,
  GET_TARGET_FOLDERS_FAILURE,
  EXPLORE_TARGET_FOLDERS_REQUEST,
  EXPLORE_TARGET_FOLDERS_SUCCESS,
  UPDATE_WITH_CREATED_FOLDER,
  TOGGLE_ITEM_SELECTION_SUCCESS,
  TOGGLE_ALL_ITEM_SELECTION_SUCCESS,
  DELETE_ITEM_SUCCESS,
  REPOSITORY_LOAD_MORE_RESULTS_REQUEST,
  REPOSITORY_LOAD_MORE_RESULTS_SUCCESS,
  REPOSITORY_LOAD_MORE_RESULTS_FAILURE,
  CONVERSATION_STATUS_REQUEST,
  CONVERSATION_STATUS_SUCCESS,
  CONVERSATION_STATUS_FAILURE,
  TSV_STATUS_SUCCESS,
  TSV_STATUS_FAILURE,
  CREATE_TSV_SUCCESS,
  ADD_APPLICATION_DROPPING_ENTITY_REQUEST,
  UPDATE_APPLICATION_DROPPING_ENTITIES_REQUEST,
  REMOVE_APPLICATION_DROPPING_ENTITY_REQUEST,
  REMOVE_ALL_APPLICATION_DROPPING_ENTITIES_REQUEST,
  OPEN_COMPARE_AFTER_SAVE,
  GET_ALL_FOLDERS_SUCCESS,
  UPDATE_REPOSITORY_WITH_FOLDERS,
  REMOVE_ALL_ITEMS_TO_COMPARE,
  REMOVE_ITEM_TO_COMPARE,
  ADD_ITEM_TO_COMPARE,
  RESET_COMPARE_ERROR,
  ADD_SELECTED_AUDIENCES,
  REMOVE_SELECTED_AUDIENCE,
  REMOVE_ALL_SELECTED_AUDIENCES,
  SET_COMPARE_ERROR,
} from '../../constants/action-types';
import { isEmpty } from '../../utils/misc';

const getInitialState = () => {
  const categories = [
    'recent',
    'my',
    'template',
    'search',
    'conversation',
    'campaign',
    'tsv',
    'twitter',
    'measure_apps',
    'measure_browsing',
    'measure_instagram',
    'instagram_follows',
  ];

  const createCategoryObject = defaultValue =>
    Object.fromEntries(categories.map(key => [key, defaultValue]));

  return {
    isLoading: false,
    isLoadingFolders: false,
    isFolderSelectorLoading: false,
    currentFolder: null,
    currentTargetFolder: null,
    data: createCategoryObject([]),
    error: false,
    prevFilter: null,
    filter: 'recent',
    targetQ: undefined,
    q: undefined,
    currentSelectedIds: [],
    path: undefined,
    totalPageCount: createCategoryObject(0),
    pagination: createCategoryObject({ page: 1, limit: 200 }),
    shouldCallLoadMore: {
      recent: false,
      my: false,
      template: false,
      search: false,
      conversation: false,
      tsv: false,
    },
    droppingEntities: {},
    folders: [],
    selectedAudiences: [],
    audiencesToCompare: [],
    compareError: false,
  };
};

const getTreeFromList = list => {
  const itemsById = Object.fromEntries(list.map(item => [item.id, item]));
  const getPath = (id, names = ['Saved queries']) => {
    const parent = itemsById[id];
    if (!parent) return '';
    if (!isEmpty(parent.path) && parent.path[0].id !== '0') {
      getPath(parent.path[0].id, names);
    }
    names.push(parent.label);
    return names;
  };
  return list.map(item => {
    const path = getPath(item.id);
    if (isEmpty(item.path) || item.path[0].id === '0') {
      return {
        id: `folder_${item.id}`,
        parent_id: 'saved-queries',
        label: item.label,
        description: path.join(' > '),
      };
    }
    return {
      id: `folder_${item.id}`,
      parent_id: `folder_${item.path[0].id}`,
      label: item.label,
      description: path.join(' > '),
    };
  });
};

export const initialState = getInitialState();

const setCurrentFilter = (state, action) => {
  if (!action.q) {
    if (action.repoFilterType === 'search') {
      return state.prevFilter;
    }

    return action.repoFilterType;
  }

  return 'search';
};

const setPrevFilter = (state, action) => {
  if (action.repoFilterType === 'all' || action.repoFilterType === 'search') {
    return state.prevFilter ? state.prevFilter : 'recent';
  }

  return action.repoFilterType;
};

const setSelectedAudiences = (state, action) => {
  if (action.repoFilterType !== 'all' && action.repoFilterType !== 'search') {
    return [];
  }

  return state.selectedAudiences;
};

const setLoadMoreData = (state, more, filter) => {
  return {
    ...state.data,
    [filter || state.filter]: [...state.data[filter || state.filter], ...more],
  };
};

const getShouldCallLoadMore = (state, totalPageCount, filter) => {
  return {
    ...state.shouldCallLoadMore,
    [filter || state.filter]:
      state.pagination[filter || state.filter].page < totalPageCount,
  };
};

const getPageCount = (total_items, limit) => {
  return Math.ceil(total_items / limit);
};

const updateConversationAudience = (data, audienceId, status) => {
  return {
    ...data,
    conversation: data.conversation.map(a => {
      if (a.id === +audienceId) {
        return { ...a, metadata: { ...a.metadata, status } };
      }
      return a;
    }),
  };
};

const updateTsvAudience = (data, audienceId, status) => {
  return {
    ...data,
    tsv: data.tsv.map(a => {
      if (a.id === +audienceId) {
        return { ...a, metadata: { ...a.metadata, status } };
      }
      return a;
    }),
  };
};

const removeDroppingEntity = (entities, appName, entityId) => {
  if (!entities || !entities[appName]) {
    return [];
  }
  return [...entities[appName].filter(entity => entity.id !== entityId)];
};

const repository = (state = initialState, action) => {
  const types = {
    [GET_REPOSITORY_REQUEST]: () => ({
      ...state,
      isLoading: true,
      isLoadingFolders: true,
      currentFolder: null,
      q: action.q ? action.q : initialState.q,
      prevFilter: setPrevFilter(state, action),
      filter: setCurrentFilter(state, action),
      pagination: {
        ...initialState.pagination,
        [state.filter]: {
          ...initialState.pagination[state.filter],
        },
      },
      path: undefined,
      selectedAudiences: setSelectedAudiences(state, action),
    }),
    [GET_REPOSITORY_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
      currentSelectedIds: [],
      shouldCallLoadMore: getShouldCallLoadMore(
        state,
        getPageCount(
          action.total_count,
          initialState.pagination[state.filter].limit
        )
      ),
      totalPageCount: {
        ...state.totalPageCount,
        [action.filter || state.filter]: getPageCount(
          action.total_count,
          initialState.pagination[state.filter].limit
        ),
      },
    }),
    [GET_REPOSITORY_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [UPDATE_REPOSITORY_WITH_FOLDERS]: () => ({
      ...state,
      isLoadingFolders: false,
      data: {
        ...state.data,
        [state.filter]: [...action.response, ...state.data[state.filter]],
      },
    }),
    [GET_FOLDER_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_FOLDER_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
      currentFolder: action.id,
      currentSelectedIds: [],
    }),
    [GET_FOLDER_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [EXPLORE_FOLDER_SUCCESS]: () => ({
      ...state,
      currentFolder: action.id,
      currentSelectedIds: [],
    }),
    [GET_TARGET_FOLDERS_REQUEST]: () => ({
      ...state,
      isFolderSelectorLoading: true,
      targetQ: action.q ? action.q : initialState.targetQ,
      currentTargetFolder: null,
    }),
    [GET_TARGET_FOLDERS_SUCCESS]: () => ({
      ...state,
      isFolderSelectorLoading: false,
      data: action.response,
      shouldCallLoadMore: getShouldCallLoadMore(
        state,
        getPageCount(
          action.total_count,
          initialState.pagination[state.filter].limit
        ),
        'my'
      ),
      totalPageCount: {
        ...state.totalPageCount,
        [action.filter || state.filter]: getPageCount(
          action.total_count,
          initialState.pagination[state.filter].limit
        ),
      },
    }),
    [GET_TARGET_FOLDERS_FAILURE]: () => ({
      ...state,
      isFolderSelectorLoading: false,
      error: true,
      message: action.message,
    }),
    [GET_TARGET_FOLDER_REQUEST]: () => ({
      ...state,
      isFolderSelectorLoading: true,
    }),
    [GET_TARGET_FOLDER_SUCCESS]: () => ({
      ...state,
      isFolderSelectorLoading: false,
      currentTargetFolder: action.id,
      data: action.response,
    }),
    [GET_TARGET_FOLDER_FAILURE]: () => ({
      ...state,
      isFolderSelectorLoading: false,
      error: true,
      message: action.message,
    }),
    [EXPLORE_TARGET_FOLDERS_REQUEST]: () => ({
      ...state,
    }),
    [EXPLORE_TARGET_FOLDERS_SUCCESS]: () => ({
      ...state,
      currentTargetFolder: action.id,
    }),
    [UPDATE_WITH_CREATED_FOLDER]: () => ({
      ...state,
      data: action.data,
      filter: action.filter || state.filter,
      currentFolder: action.currentFolder || state.currentFolder,
      path: action.path || state.path,
    }),
    [TOGGLE_ITEM_SELECTION_SUCCESS]: () => ({
      ...state,
      currentSelectedIds: action.data,
    }),
    [TOGGLE_ALL_ITEM_SELECTION_SUCCESS]: () => ({
      ...state,
      currentSelectedIds: action.data,
    }),
    [DELETE_ITEM_SUCCESS]: () => ({
      ...state,
      currentSelectedIds: [],
    }),
    [REPOSITORY_LOAD_MORE_RESULTS_REQUEST]: () => ({
      ...state,
      isLoadingMore: true,
      pagination: {
        ...state.pagination,
        [action.filter || state.filter]: {
          ...state.pagination[action.filter || state.filter],
          page: state.pagination[action.filter || state.filter].page + 1,
        },
      },
    }),
    [REPOSITORY_LOAD_MORE_RESULTS_SUCCESS]: () => ({
      ...state,
      isLoadingMore: false,
      data: setLoadMoreData(state, action.response, action.filter),
      shouldCallLoadMore: getShouldCallLoadMore(
        state,
        getPageCount(
          action.total_count,
          initialState.pagination[action.filter || state.filter].limit
        )
      ),
    }),
    [REPOSITORY_LOAD_MORE_RESULTS_FAILURE]: () => ({
      ...state,
      isLoadingMore: false,
    }),
    [CONVERSATION_STATUS_REQUEST]: () => ({
      ...state,
      filter: 'conversation',
    }),
    [CONVERSATION_STATUS_SUCCESS]: () => ({
      ...state,
      data: updateConversationAudience(
        state.data,
        action.response && action.response.node_id,
        'ready'
      ),
    }),
    [CONVERSATION_STATUS_FAILURE]: () => ({
      ...state,
      data: updateConversationAudience(
        state.data,
        action.response && action.response.node_id,
        'error'
      ),
    }),
    [CREATE_TSV_SUCCESS]: () => ({
      ...state,
      filter: 'tsv',
    }),
    [TSV_STATUS_SUCCESS]: () => ({
      ...state,
      data: updateTsvAudience(state.data, action.response.node_id, 'ready'),
    }),
    [TSV_STATUS_FAILURE]: () => ({
      ...state,
      data: updateTsvAudience(state.data, action.response.node_id, 'error'),
    }),
    [ADD_APPLICATION_DROPPING_ENTITY_REQUEST]: () => ({
      ...state,
    }),
    [UPDATE_APPLICATION_DROPPING_ENTITIES_REQUEST]: () => ({
      ...state,
      droppingEntities: {
        ...state.droppingEntities,
        [action.appName]: action.entities,
      },
    }),
    [REMOVE_APPLICATION_DROPPING_ENTITY_REQUEST]: () => ({
      ...state,
      droppingEntities: {
        ...state.droppingEntities,
        [action.appName]: removeDroppingEntity(
          state.droppingEntities,
          action.appName,
          action.audienceId
        ),
      },
    }),
    [REMOVE_ALL_APPLICATION_DROPPING_ENTITIES_REQUEST]: () => ({
      ...state,
      droppingEntities: {
        ...state.droppingEntities,
        [action.appName]: [],
      },
    }),
    [OPEN_COMPARE_AFTER_SAVE]: () => ({
      ...state,
    }),
    [GET_ALL_FOLDERS_SUCCESS]: () => ({
      ...state,
      folders: getTreeFromList(action.data),
    }),
    [ADD_ITEM_TO_COMPARE]: () => ({
      ...state,
      audiencesToCompare:
        state.audiencesToCompare.length < 3
          ? [...state.audiencesToCompare, action.audience]
          : state.audiencesToCompare,
      compareError: state.audiencesToCompare.length === 3,
    }),
    [REMOVE_ITEM_TO_COMPARE]: () => ({
      ...state,
      audiencesToCompare: state.audiencesToCompare.filter(
        audience => audience.id !== action.id
      ),
    }),
    [REMOVE_ALL_ITEMS_TO_COMPARE]: () => ({
      ...state,
      audiencesToCompare: [],
    }),
    [RESET_COMPARE_ERROR]: () => ({
      ...state,
      compareError: false,
    }),
    [SET_COMPARE_ERROR]: () => ({
      ...state,
      compareError: true,
    }),
    [ADD_SELECTED_AUDIENCES]: () => ({
      ...state,
      selectedAudiences: [...state.selectedAudiences, ...action.audiences],
    }),
    [REMOVE_SELECTED_AUDIENCE]: () => ({
      ...state,
      selectedAudiences: state.selectedAudiences.filter(
        audience => audience.id !== action.audienceId
      ),
    }),
    [REMOVE_ALL_SELECTED_AUDIENCES]: () => ({
      ...state,
      selectedAudiences: [],
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default repository;
